import React from 'react';
import { withRouter } from 'react-router-dom';
import { setLoad } from '../../components/loading';
import { getChain, getUptime, getWeb3 } from '../../others/helper';

class Transactions extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            txs: [],
            page: 0,
            lastPage: 0,
        }
    }

    componentDidMount = async () => {
        await setLoad(true);
        const chain = await getChain();
        const web3 = await getWeb3();
        let page = new URLSearchParams(this.props.location.search).get("page");
        page = page ? parseFloat(page) : 0;
        let txs = await web3.transactions.getTxs(chain, { limit: 20, offset: page * 20 });
        let amount = await web3.transactions.countTxs({ chain });
        await this.setState({
            txs,
            page,
            lastPage: Math.floor(amount / 20)
        });
        await setLoad(false);
    }

    render() {
        return (<>
            <section className="block-explorer-section section bg-bottom">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="center-heading">
                                <h2 className="section-title">Latest Transactions</h2>
                            </div>
                        </div>
                        <div className="offset-lg-3 col-lg-6">
                            <div className="center-text">
                                <p></p>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="table-responsive">
                                <table className="table table-striped table-latests">
                                    <thead>
                                        <tr>
                                            <td>Hash</td>
                                            <td>Age</td>
                                            <td>Status</td>
                                            <td>From</td>
                                            <td>To</td>
                                            <td>Tag</td>
                                            <td>Amount</td>
                                            <td>Fee</td>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.state.txs.map(tx => <tr key={`id-${tx.hash}`}>
                                            <td><a href={`/tx/${tx.hash}`}>{tx.hash.substring(0, 20)}...</a></td>
                                            <td>{getUptime(tx.created)}</td>
                                            <td>{tx.status}</td>
                                            <td><a href={`/address/${tx.from[0]}`}>{tx.from[0].substring(0, 20)}...</a></td>
                                            <td><a href={`/address/${tx.to[0]}`}>{tx.to[0].substring(0, 20)}...</a></td>
                                            <td>{tx.tag ? tx.tag : '-'}</td>
                                            <td>{tx.amount} BWS</td>
                                            <td>{tx.fee} BWS</td>
                                        </tr>)}
                                    </tbody>
                                </table>
                            </div>
                            <div>
                                {this.state.page > 0 && <span>
                                    <a href={`/tx?page=0`}>{`<<`}</a>
                                    &nbsp;&nbsp;&nbsp;&nbsp;
                                    <a href={`/tx?page=${this.state.page - 1}`}>{`< previous page`}</a>
                                </span>}
                                {this.state.page < this.state.lastPage && <span style={{ float: 'right' }}>
                                    <a href={`/tx?page=${this.state.page + 1}`}>{`next page >`}</a>
                                    &nbsp;&nbsp;&nbsp;&nbsp;
                                    <a href={`/tx?page=${this.state.lastPage}`}>{`>>`}</a>
                                </span>}
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>)
    }
}

export default withRouter(Transactions);